import { useState, useEffect ,useCallback , useRef} from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link, Link as RouterLink, useNavigate, useParams, useLocation, NavLink } from 'react-router-dom';
import { useForm } from "react-hook-form";
import imageCompression from 'browser-image-compression';
import { toast } from "react-toastify";
import QRCode from 'qrcode.react';

import Multiselect from 'multiselect-react-dropdown';
import "react-data-table-component-extensions/dist/index.css";
import * as React from 'react';
import $ from 'jquery';
import TableToExcel from '@linways/table-to-excel';
import DataTable from 'react-data-table-component'; 
// @mui
import { styled, useTheme } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import * as userActions from "../../actions/userActions";
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import '../common.scss';
import * as reportActions from "../../actions/reportActions";
import Loader from "../../components/Loader"; 

import AccessDenied from '../common/AccessDenied';
import * as beatPlanActions from "../../actions/beatPlanActions";
import * as masterAction from "../../actions/masterAction";

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------
const RepaymentSchedule = (props) => {
    const { leadId, id } = useParams();
    const location = useLocation();
    const { actions, usersData, fetchLeadIdDocument, allLeadDocumentByLeadData, isActive,leadInfo,backToLeadHandler,enableCamDetailsHandler,selectionVersioningID } = props;
    const theme = useTheme();
   
    
    const { brief } = useParams();
    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
    
    const navigate = useNavigate();
 
    const [permissions, setPermissions] = useState([]);
    const [userRoleType, setUserRoleType] = useState('User');
    const [loggeInUserID, setLoggeInUserID] = useState('');

    const [allTags, setAllTags] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [displayRecords, setDisplayRecords] = useState([]);
    const [loanDetailsEMIS, setLoanDetailsEMIS] = useState([]);
 
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');

    const [sendCrifOpenModal, setSendCrifOpenModal] = React.useState(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [sendCrifFormData, setSendCrifFormData] = useState({ email_address: '' });
    const [preloaderStatus, setPreloaderStatus] = useState(false);

    const [viewModulePermissionStatus, setViewModulePermissionStatus] = useState(false);
    const [userHasPermission, setUserHasPermission] = useState(true);

    const [beatPlanLocation, setBeatPlanLocation] = useState([]);
    const [allCampaigns, setAllCampaigns] = useState([]);
    const [selectedVisitType, setSelectedVisitType] = useState([]);
    const [loanDetailStatus, setLoanDetailStatus] = useState(true);
    const [activeTab, setActiveTab] = useState(0);
    const [versioningLoans, setVersioningLoans] = useState([]);
	const [businessDoneLoan, setBusinessDoneLoan] = useState([]);
    const [reportName, setReportName] = useState('');
    const [cronRunDateArr, setCronRunDateArr] = useState([]);
    const [cronRunTabsReloadStatus, setCronRunTabsReloadStatus] = useState(true);
    const [activeLoanTab, setActiveLoanTab] = useState(0);
    const [auditAllLoansButtonStatus, setAuditAllLoansButtonStatus] = useState(false);

    const [keyword, setKeyword] = useState('');
    const [isENACHRegistrationChecked, setIsENACHRegistrationChecked] = useState(false);
    const [selectedTag, setSelectedTag] = useState('');
    
    const [totalOutstandingAmt, setTotalOutstandingAmt] = useState(0);
    const[intentUrlRazorpay, setIntentUrlRazorpay] = useState('');
 
    const [formValues, setFormValues] = useState({
        amount: '',
        amountRazorpay:''
    });

    const [qrCodeAmount, setQrCodeAmount] = useState(0);
    const [qrCodeAmountRazorpay, setQrCodeAmountRazorpay] = useState(0);

    const [selectedDocumentFiles, setSelectedDocumentFiles] = useState([]);
    const [compressedFile, setCompressedFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [isMobile , setIsMobile] = useState(null);

    const childRef = useRef();
    const fileInputRef = useRef();
    const cameraInputRef = useRef();

    const [previews, setPreviews] = useState([]);
    const [compressedFiles, setCompressedFiles] = useState([]);
    const [imageDetails, setImageDetails] = useState([]); 
    const [preloaderSubmitStatus, setPreloaderSubmitStatus] = useState(false);
    const [page, setPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [propLeadId, setPropLeadId] = useState('');
    const RECORDS_PER_PAGE = 200;
    const [activeListIdentifier, setActiveListIdentifier] = useState(0);

    const [googleChatAccessTokenVal, setGoogleChatAccessTokenVal] = useState('');
    const [googleUserIdVal, setGoogleUserIdVal] = useState('');
    const [googleChatUrlVal, setGoogleChatUrlVal] = useState('');
    const [dynamicTabsName , setDynamicTabsName] = useState([]);
    const [additionalDetails , setAdditionalDetails] = useState([]);
    useEffect(() => {

        if (brief !== undefined ) {
            setReportName(brief); 
        }
        // check user is logged-in or not
        const authToken = localStorage.getItem('authToken');
        if (authToken === null) {
            navigate('/login');
        }

        if (id !== undefined ) {
            const idVal = atob(id); 
            setPropLeadId(idVal);           
             setLoanDetailStatus(true);
        } 
    }, [id,setReportName]);

    
 
    const handleKeywordChange = (event) => {
        setKeyword(event.target.value); 
    };
    const handleENACHRegistrationChange = (event) => {
         setIsENACHRegistrationChecked(event.target.checked);
    };

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    useEffect(() => {

        if (isActive) { 
        setPreloaderStatus(true);

        const today = new Date();
        const todayFormatted = formatDate(today);

        setStartDate(todayFormatted);
        setEndDate(todayFormatted);

        setValue("start_date", todayFormatted);
        setValue("end_date", todayFormatted);

        // console.log("111111 - id = ",id);

        if (id !== undefined ) {
            setDisplayRecords([]);
            setLoanDetailsEMIS([]);
            setVersioningLoans([]);
            const idVal = atob(id); 
            setPropLeadId(idVal); 
            let reportName = '';
            if (brief !== undefined ) {
                reportName = brief; 
            }
            // alert(reportName);
            // alert(idVal);      
             setLoanDetailStatus(true);
             setAuditAllLoansButtonStatus(true);
 
            setLoading(true);
            const offset = (page - 1) * RECORDS_PER_PAGE;
             const params = { 'start': '0', 'length': config.MAX_RECORDS, 'start_date': todayFormatted, 'end_date': todayFormatted ,'lead_id' : propLeadId ,'reportName' : reportName, 'keyword' : keyword ,'activeListIdentifier' : activeListIdentifier , "userRoleType" :userRoleType , "page" : page ,"limit": RECORDS_PER_PAGE,  "offset" : offset };
                const requestData = encryptData(params);
                 const response = actions.getRepaymentScheduleData(requestData, false);
                response.then((result) => {
                    setLoading(false);
                    // console.log("Promise resolved -  getRepaymentScheduleData:", result);
                    setTotalRows(result.data?.total || 0);
                    if (result.data.success === 1) {
                        setPreloaderStatus(false);
                        const results = result.data.data.all_records;
                        const resultArr = Object.keys(results).map((key) => results[key]);
                        setVersioningLoans(resultArr);
                        setDisplayRecords(resultArr);    
                        console.log("resultArr = ",resultArr);
                         const defaultTabIndex = (resultArr.length >0) ? (resultArr.length - 1) : 0;
                        setActiveTab(defaultTabIndex);
                         
                        setDynamicTabsName(result.data?.tabsName || []);
                        setAdditionalDetails(result.data?.additionalDetails || []);
                    } else {
                        setPreloaderStatus(false);
                        setDisplayRecords([]);
                        setLoanDetailsEMIS([]);
                        setBusinessDoneLoan([]);
                    }
                }).catch((error) => {
                    setPreloaderStatus(false);
                    console.error("Promise rejected -  getRepaymentScheduleData:", error);
                });
        }else{
            setLoading(true);
            const offset = (page - 1) * RECORDS_PER_PAGE;
            const params = { 'start': '0', 'length': config.MAX_RECORDS, 'start_date': todayFormatted, 'end_date': todayFormatted,'lead_id' : propLeadId, 'keyword' : keyword , "page" : page ,"limit": RECORDS_PER_PAGE,
            "offset" : offset ,'activeListIdentifier' : activeListIdentifier, "userRoleType" :userRoleType };
            const requestData = encryptData(params);
             const response = actions.getRepaymentScheduleData(requestData, false);
            response.then((result) => {
                setLoading(false);
                // console.log("Promise resolved -  getRepaymentScheduleData:", result);
                setTotalRows(result.data?.total || 0);
                if (result.data.success === 1) {
                    setPreloaderStatus(false);
                    const results = result.data.data.all_records;
                    const resultArr = Object.keys(results).map((key) => results[key]);
                    console.log("resultArr 3 = ",resultArr);
                    setDisplayRecords(resultArr);
                     setLoanDetailsEMIS([]);
                    setBusinessDoneLoan([]);
                    setDynamicTabsName(result.data?.tabsName || []);
                    setAdditionalDetails(result.data?.additionalDetails || []);
                } else {
                    setPreloaderStatus(false);
                    setDisplayRecords([]);
                    setLoanDetailsEMIS([]);
                    setBusinessDoneLoan([]);
                }
            }).catch((error) => {
                setPreloaderStatus(false);
                console.error("Promise rejected -  getRepaymentScheduleData:", error);
            });
        }

     }
    }, [isActive, setDisplayRecords,setLoanDetailsEMIS,setLoanDetailStatus,id, setBusinessDoneLoan,setVersioningLoans, setCronRunDateArr, setTotalOutstandingAmt, totalOutstandingAmt,page]);
 
    const onSubmit = (data) => {
        
        setPreloaderStatus(true);
        setLoading(true);
        const offset = (page - 1) * RECORDS_PER_PAGE;
        const params = {
            'keyword' : keyword,
            'start': '0',
            'length': config.MAX_RECORDS,"brief" :'case_management_system', "page" : page ,"limit": RECORDS_PER_PAGE,
            "offset" : offset,
            'lead_id' : propLeadId,
            'activeListIdentifier' : activeListIdentifier , "userRoleType" :userRoleType
        };

        const requestData = encryptData(params);
         const response = actions.getRepaymentScheduleData(requestData, false);
        response.then((result) => {
            setLoading(false);
            // console.log("Promise resolved -  lead list:", result);
            setTotalRows(result.data?.total || 0);
            
            if (result.data.success === 1) {
                setPreloaderStatus(false);
               
                const results = result.data.data.all_records;
                const resultArr = Object.keys(results).map((key) => results[key]);

                setDisplayRecords(resultArr);
                console.log("resultArr 2 = ",resultArr);
                setDynamicTabsName(result.data?.tabsName || []);
                setAdditionalDetails(result.data?.additionalDetails || []);
            } else {
                setPreloaderStatus(false);
                setDisplayRecords([]);
                setAdditionalDetails([]);
            }
        }).catch((error) => {
            setPreloaderStatus(false);
            console.error("Promise rejected -  lead list:", error);
        });
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        setPage(newPage);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1); // Reset to the first page when searching
        setPage(1);
    };

    const filteredItems = displayRecords.filter(item => {
        const AgreementNo = item.AgreementNo?.toLowerCase() || '';
        const CustomerName = item.CustomerName?.toLowerCase() || '';
        return (
            AgreementNo.includes(searchQuery.toLowerCase()) ||
            CustomerName.includes(searchQuery.toLowerCase())            
        );
    });

    const startIndex = (currentPage - 1) * config.HUNDREAD_PER_PAGE;
    const endIndex = startIndex + config.HUNDREAD_PER_PAGE;
    const paginatedItems = filteredItems.slice();
    const totalPages = Math.ceil(filteredItems.length / config.HUNDREAD_PER_PAGE);
     
    const exportLoansReport = async () => {
        const table = document.getElementById('exportLoansReportExcelFile');
        
        // Debugging log: Check if table is correctly selected
        console.log('Table:', table);
        
        const headersRow = table.querySelector('thead tr');
        const headers = Array.from(headersRow.querySelectorAll('th'));
        const actionColumnIndex = headers.findIndex(th => th.innerText.trim() === 'Action');
        
        // Debugging logs: Check headersRow and actionColumnIndex
        console.log('Headers Row:', headersRow);
        console.log('Action Column Index:', actionColumnIndex);
        
        if (actionColumnIndex !== -1) {
            // Debugging log: Check the header element to remove
            console.log('Header to Remove:', headers[actionColumnIndex]);
            
            headersRow.removeChild(headers[actionColumnIndex]);
        } else {
            console.log('Action column not found.');
        }
    
        TableToExcel.convert(table, {
            name: 'case_management_system_report.xlsx',
            sheet: {
                name: 'Audit-Report',
            },
        });
    
        // Re-append the action column header if it was removed
        if (actionColumnIndex !== -1) {
            headersRow.appendChild(headers[actionColumnIndex]);
        }
    }; 
    
    const selectRefSL = useRef(null);  
    const formatDateForValue = (date) => {
        if (!date || Number.isNaN(new Date(date).getTime())) {
            return '';  // Return an empty string for invalid or empty dates
        }
    
        const newDate = new Date(date);
        const year = newDate.getFullYear();
        const month = String(newDate.getMonth() + 1).padStart(2, '0');
        const day = String(newDate.getDate()).padStart(2, '0');
    
        return `${day}-${month}-${year}`;
    };


    /*  
    "installmentNo": 0,
"days": 27,
"dueDate": "05 Apr 26",
"emi": 4292.1,
"principleDue": 0.0,
"interestDue": 4292.1,
"pos": 270000.0,
"fees": 0,
"penalties": 0,
"paid": 0,
"inAdvance": 0,
"late": 0,
"outStanding": 4292.1,
"dpdBucket": "",
"isPaid": false,
    */
    const columns = [
       
        {
        name: 'Installment No',
        sortable: true,
         selector: row => row.installmentNo,
        },        
        {
            name: 'EMI',
            selector: row => row.emi,
            sortable: true
        },
         {
            name: 'Days',
            selector: row => row.days,
            sortable: true
        },
        {
            name: 'Due Date',
            selector: row => row.dueDate,
            sortable: true 
        }  
        ,
        {
            name: 'Principle Due',
            selector: row => row.principleDue,
            sortable: true 
        },
        {
            name: 'InterestDue',
            selector: row => row.interestDue,
            sortable: true 
        },
        {
            name: 'POS',
            selector: row => row.pos,
            sortable: true 
        },
        {
            name: 'Fees',
            selector: row => row.fees,
            sortable: true 
        } ,
        {
            name: 'Penalties',
            selector: row => row.penalties,
            sortable: true 
        } ,
        {
            name: 'Paid',
            selector: row => row.paid,
            sortable: true 
        },
        {
            name: 'In Advance',
            selector: row => row.inAdvance,
            sortable: true 
        },
        {
            name: 'Late',
            selector: row => row.late,
            sortable: true 
        },
        {
            name: 'Outstanding',
            selector: row => row.outStanding,
            sortable: true 
        },
        {
            name: 'DPD Bucket',
            selector: row => row.dpdBucket,
            sortable: true 
        },
        {
            name: 'IsPaid',
            selector: row => row.isPaid ? 'Yes' : 'No',
            sortable: true 
        }         
        
    ];

    // Conditional row styles to change text color
        const conditionalRowStyles = [
            {
            when: row => row.AgreementNo === 'Success',   
            style: {
                color: 'green',
            },
            },
            {
            when: row => row.AgreementNo === 'Aborted',  
            style: {
                color: 'red',
            },
            },
            {
            when: row => row.AgreementNo === 'Failed',  
            style: {
                color: 'red',
            },
            },
        ];

    

    function isMobileDevice() {
     return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    }

     const handleImageChange = async (event) => {
    setPreloaderStatus(true);
    const file = event.target.files[0];
    if (!file) return;

    const options = {
        maxSizeMB: 1,
        useWebWorker: true,
        maxWidthOrHeight: undefined,
    };

    try {
        const compressedFile = await imageCompression(file, options);

        const base64Data = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsDataURL(compressedFile);
        });

        const imageData = {
        name: file.name,
        originalSize: (file.size / 1024).toFixed(2),
        compressedSize: (compressedFile.size / 1024).toFixed(2),
        previewUrl: URL.createObjectURL(compressedFile),
        base64: base64Data,
        };

        setPreviews([imageData.previewUrl]);
        setCompressedFiles([compressedFile]);
        setSelectedDocumentFiles([{ file: imageData.base64, name: imageData.name }]);
        setImageDetails([imageData]);
        setPreloaderStatus(false);
    } catch (error) {
        console.error("Image processing failed:", error);
        setPreloaderStatus(false);
    }
    };
    
        const handleDelete = (index) => {
            // Revoke preview URL
            setImageDetails(prevDetails => {
                const target = prevDetails[index];
                if (target?.previewUrl) {
                URL.revokeObjectURL(target.previewUrl);
                }
    
                const newDetails = prevDetails.filter((_, idx) => idx !== index);
    
                // Sync other states based on new imageDetails
                setPreviews(newDetails.map(img => img.previewUrl));
                setCompressedFiles(prev => prev.filter((_, idx) => idx !== index));
                setSelectedDocumentFiles(newDetails.map(img => ({
                file: img.base64,
                name: img.name
                })));
    
                return newDetails;
            });
            };
    
    const handleDocumentFileChange = (e) => {
    const file = e.target.files[0]; // Only take the first file
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
        const base64Data = event.target.result;
        const fileName = file.name;
        setSelectedDocumentFiles([{ file: base64Data, name: fileName }]);
    };
    reader.readAsDataURL(file);
};

    const [openPaymentModal, setOpenPaymentModal] = React.useState(false);
    const btnOpenPaymentModal = () => setOpenPaymentModal(true);
    const handlePaymentModalClose = () => {
        setOpenPaymentModal(false);
        setSelectedDocumentFiles([]);  
    };

    const handleCallChild = () => {
       const tab = document.getElementById('pills-payment_documents-tab');
       if (tab) {
         tab.click();
        } 
    };
 
    const handlePaymentFormSubmit = (data) => {
        
        if (!selectedDocumentFiles || selectedDocumentFiles.length === 0) {
            toast.error("No file has been selected.", {
                position: "top-right",
            });
        } else {
            const params = {"upload_file": selectedDocumentFiles , "AgreementNo" : businessDoneLoan.AgreementNo};
             setPreloaderStatus(true);
            const requestData = encryptData(params);
            const response = actions.uploadLoanPaymentData(requestData, navigate);

            response.then((result) => {
                 if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });
                    setPreloaderStatus(false);
                    reset();
                    setOpenPaymentModal(false);
                    setSelectedDocumentFiles([]);
                    setImageDetails([]);
                    handleCallChild();  
                   
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                    setPreloaderStatus(false);
                }
            }).catch((error) => {
                toast.error(error, {
                    position: "top-right",
                });
            });
        }
    };

    const [open, setOpen] = React.useState(false);
    const btnOpenUploadMissingData = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setSelectedItrFiles([]); // Reset selected ITR files
    };
    const [selectedItrFiles, setSelectedItrFiles] = useState([]);

    const handleItrFileChange = (e) => {
        const files = Array.from(e.target.files);
        const base64Files = [];

        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const base64Data = event.target.result;
                const fileName = file.name;
                base64Files.push({ file: base64Data, name: fileName });
                if (base64Files.length === files.length) {
                    setSelectedItrFiles(base64Files);
                }
            };
            reader.readAsDataURL(file);
        });
    };

    

    const handleFormSubmit = (data) => {

        if (!selectedItrFiles || selectedItrFiles.length === 0) {
            toast.error("No file has been selected.", {
                position: "top-right",
            });
        } else {

            const params = {"upload_file": selectedItrFiles };

            // setPreloaderStatus(true);
            const requestData = encryptData(params);
            const response = actions.uploadMissingData(requestData, navigate);

            response.then((result) => {
                // console.log("Promise resolved - uploadLeads form:", result); 
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });
                    setPreloaderStatus(false);
                    reset();
                    setOpen(false);
                    setSelectedItrFiles([]);
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                    setPreloaderStatus(false);
                }
            }).catch((error) => {
                toast.error(error, {
                    position: "top-right",
                });
            });
        }
    }; 
    
    const { importName } = useParams();
    const [pageHeading , setPageHeading]  = useState('');
    const [iframeSrc , setIframeSrc]  = useState('');
    const [iframeLoaded, setIframeLoaded] = useState(false);

    useEffect(() => {
        const authToken = localStorage.getItem('authToken');

            const googleChatAccessToken = localStorage.getItem('googleChatAccessToken');
            const googleUserId = localStorage.getItem('googleUserId');
            const googleChatUrl = localStorage.getItem('googleChatUrl');


            if(googleChatAccessToken !== null && googleChatAccessToken !== ""){
                //  alert(googleChatAccessToken);
                setGoogleChatAccessTokenVal(googleChatAccessToken);
            }

            if(googleUserId !== null && googleUserId !== ""){
                // alert(googleUserId);
                setGoogleUserIdVal(googleUserId);
                setGoogleChatUrlVal(googleChatUrl);
            } 

        let appUrl = config.APP_URL;
        appUrl = appUrl.replace('/public/', '/'); 
            setPageHeading('Loans Tagging');
            setIframeSrc(`${appUrl}excel_report/excel_import_loans_tagging.php?referrer=${btoa('lms_page')}&authToken=${authToken}`);        
        setIframeLoaded(true);
    }, [importName, setIframeLoaded , setGoogleChatAccessTokenVal,setGoogleUserIdVal]);

    const handleIframeLoad = () => {
        setIframeLoaded(true);
    }; 
     
    const [showHideTagStatus, setShowHideTagStatus] = useState(false);
    const handleToggle = () =>{
         setShowHideTagStatus(prevState => !prevState);  
    }
 
 
    if (!userHasPermission) {
        // Redirect or render an access denied message
      //  return <AccessDenied />;
    }


    useEffect(() => {
            if (activeListIdentifier !== null) {
                onSubmit();
            }
    }, [activeListIdentifier,userRoleType]);

    const listDisplayHandler = (listIdentifier) => {
        setActiveListIdentifier(listIdentifier);
    }

 
    return (
        <>  
            <Helmet>
                <title>Repayment Schedule | Ckers</title>
            </Helmet>
            <Container>                
                <div id='main-wrap'  className={loanDetailStatus ? "d-none mb-3 mmt-7 filter" : "mb-3 mmt-7 filter d-none"}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className='row mx-0'>

                            <div className='col'>
                                <div className='form-group'>
                                    <label htmlFor="keyword">
                                        <span>Keyword</span>
                                        <input type='text' name='keyword' id='keyword' className='form-control'{...register('keyword')} placeholder="Enter your value here..." onChange={handleKeywordChange}/>
                                    </label>
                                </div>
                            </div>
 

                            <div className='col'>
                                <div className='form-group mb-2'>
                                    <span className='d-block'>&nbsp;</span>
                                    <button className='btn btn-primary'>Search</button>
                                </div>
                            </div>
  
                        </div>
                    </form>
                </div>

                <div>
                  
                        {(showHideTagStatus) && (<div className='table-wrap'>
                            {!iframeLoaded && <div><div className='p-spinner'><div className="spinner">&nbsp;</div></div></div>}
                            <iframe
                                title="Report"
                                width="100%"
                                height="130"
                                src={iframeSrc}
                                frameBorder="0"
                                allowFullScreen
                                onLoad={handleIframeLoad}
                                style={{ display: iframeLoaded ? 'block' : 'none' }}
                            />
                        </div>
                        )
                        }
                        </div> 

                <div id="main-wrap" >

                   <div className="row justify-content-between mt-4">
                    {dynamicTabsName.length > 0 && (
                        <>
                        <div className="col-md-12">
                            <ul className="nav nav-tabs" id="myTab" role="tablist" style={{ marginBottom: "0px" }}>
                                {dynamicTabsName.map((tabName, index) => (
                                    <li className="nav-item" key={index}>
                                        <a
                                            className="nav-link"
                                            id={`${tabName}-tab`}
                                            data-bs-toggle="tab"
                                            href={`#${tabName}`}
                                            role="tab"
                                            onClick={() => {setActiveTab(index); setActiveListIdentifier(index);}}
                                        >
                                            {tabName.toUpperCase()}
                                        </a>
                                    </li>
                                ))}
                            </ul>


                        </div>  

                        <div className="col-md-12" style={{ background:"aliceblue"}}>
                            {additionalDetails && Object.keys(additionalDetails).length > 0 && (
                                <div className="additional-details-wrap p-3 mb-3">
                                    <div className="row">
                                        {Object.entries(additionalDetails).map(([key, value], index) => (
                                            <div className="col-md-6" key={index}>
                                                <label className="form-label">
                                                    {key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())} :
                                                </label>
                                                <div className="form-control-plaintext">{value}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                        </>
                    )  }
                    </div>     
                    

                    <div className="row justify-content-between mt-4">
                        <div className="col-md-7">
                            <Typography className="line-initial" variant="h4" sx={{ mb: 0 }}>
                              Repayment Schedule
                            </Typography> 
                        </div>
                        <div className='col-md-5 text-end ps-lg-5'>                            
                      
                            <>
                            <div className="form-group d-flex justify-content-end align-items-center">
                                <label htmlFor="search" className='w-100 d-none'>
                                    {/* Search : */}
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        id="search"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                </label>
                                <button className="btn btn-info text-white ms-3 d-none" onClick={() => exportLoansReport()}>
                                    Export
                                </button>                                
                            </div>
                            <div className="float-left mb-2"><b>Total Records : {totalRows}</b></div>
                            </>
                                              
                        </div>
                    </div>

                    
                    
                        <DataTable
                            // title="My DataTable with Expandable Rows"
                            columns={columns}
                            data={displayRecords}
                            progressPending={loading}
                            pagination
                            paginationServer
                            paginationTotalRows={totalRows}
                            paginationPerPage={RECORDS_PER_PAGE}
                            onChangePage={handlePageChange}
                            conditionalRowStyles={conditionalRowStyles}
                            // pagination
                        />
                </div>
                {preloaderStatus && <Loader />}
            </Container>
            

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className='modal-custom rounded'>
                    <div className='modal-head'>
                        <h4 id="modal-title">Upload Additional Data</h4>
                        <Button onClick={handleClose} color="primary" className=' btn'>
                            <i className="bi bi-x">&nbsp;</i>
                        </Button>
                    </div>
                    
                    <div className='modal-body'>
                        <div>
                            <form onSubmit={handleSubmit(handleFormSubmit)} encType="multipart/form-data">
                                <div className="row mx-0">
                                    <div className="col-md-6 px-0">
                                        <div className="form-group">
                                            <label htmlFor="itr_file">
                                                <span>File Upload <a style={{ color: "red" }}>*</a></span>
                                                <input
                                                    type='file'
                                                    id='itr_file'
                                                    name='itr_file'
                                                    className='form-control'
                                                    {...register('itr_file')}
                                                    onChange={handleItrFileChange}
                                                />
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-12 px-0">
                                        <div className="form-group mb-0">
                                            <button className="btn btn-primary mt-2"
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Modal>

        

        </>
    );
}

function mapStateToProps(state) {
    return {
        getRepaymentScheduleData: state.getRepaymentScheduleData,
    }
} 

function mapDispatchToProps(dispatch) { 
    return {
        actions: bindActionCreators(Object.assign(reportActions.default, userActions.default, beatPlanActions.default, masterAction.default), dispatch),
    }
} 
export default connect(mapStateToProps, mapDispatchToProps)(RepaymentSchedule);   